var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 171,
    viewBox: "0 0 186 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4293 50.1941L57.8587 3.17236M155.821 50.1941L128.391 3.17236M122.451 132.482C115.909 142.281 104.904 148.166 93.1216 148.166C81.3388 148.166 70.3344 142.281 63.7918 132.482M141.981 167.748H44.2694C36.9891 168.233 30.4189 163.401 28.7131 156.307L18.6739 89.3789H167.576L157.537 156.307C155.831 163.401 149.261 168.233 141.981 167.748ZM14.7554 89.3789C8.26309 89.3789 3 84.1158 3 77.6235C3 71.1311 8.26309 65.868 14.7554 65.868H171.495C177.987 65.868 183.25 71.1311 183.25 77.6235C183.25 84.1158 177.987 89.3789 171.495 89.3789H14.7554ZM59.8179 108.971C60.9 108.971 61.7772 109.848 61.7772 110.931C61.7772 112.013 60.9 112.89 59.8179 112.89C58.7359 112.89 57.8587 112.013 57.8587 110.931C57.8587 109.848 58.7359 108.971 59.8179 108.971ZM126.432 108.971C127.514 108.971 128.391 109.848 128.391 110.931C128.391 112.013 127.514 112.89 126.432 112.89C125.35 112.89 124.473 112.013 124.473 110.931C124.473 109.848 125.35 108.971 126.432 108.971Z",
    stroke: "#F8BF2F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.51afc228.svg";
export { ForwardRef as ReactComponent };